// Single source of truth for the visible app version.
//
// v190.7 — Auto-versioning: the visible stamp is now generated at every
// `yarn start` / `yarn build` from git metadata (see scripts/write-build-info.js).
// The old hardcoded "v119.220-2026-07-09" string caused a trust bug where the
// UI kept advertising an ancient date across many deploys. Never hardcode a
// version here again — the `build-info.generated.js` fallback is imported
// dynamically and refreshes automatically.
let _version = "v0-dev";
let _buildDate = new Date().toISOString().slice(0, 10);
try {
  // eslint-disable-next-line global-require
  const gen = require("../build-info.generated");
  if (gen && gen.APP_VERSION) _version = gen.APP_VERSION;
  if (gen && gen.APP_BUILD_DATE) _buildDate = gen.APP_BUILD_DATE;
} catch (_e) {
  // build-info.generated.js absent (first run before prestart). Fall through
  // to the safe dev default — a subsequent restart regenerates the stamp.
}
export const APP_VERSION = _version;
export const APP_BUILD_DATE = _buildDate;
